module.exports = __webpack_public_path__ + "img/sprava-servera.2a33162d.svg";